import { Message } from '../../../types/chat';
import { HistoryMessage } from '../../../types/chat';

// 创建用户消息
export const createUserMessage = (text: string): Message => ({
    text,
    role: 'self',
    timestamp: new Date().toISOString(),
    nickname: '我',
    type: 'text'
});

// 创建初始助手消息
export const createInitialAssistantMessage = (id: string): Message => ({
    id,
    role: 'assistant',
    text: '',
    timestamp: new Date().toISOString(),
    nickname: 'AI助手',
    type: 'loading',
});

// 格式化历史消息
export const formatHistoryMessage = (msg: HistoryMessage): Message => {
    if (msg.type === 'ui') {
        return {
            id: msg.id,
            role: 'assistant',
            type: 'ui',
            ui_type: msg.ui_type,
            ui_data: msg.ui_data,
            ui_state: msg.ui_state,
            timestamp: msg.created_at,
            nickname: 'AI助手',
            text: '这是一个ui消息'
        } as Message;
    }
    
    return {
        id: msg.id,
        text: msg.content || '',
        role: msg.role === 'user' ? 'self' : 'assistant',
        timestamp: msg.created_at,
        nickname: msg.role === 'user' ? '我' : 'AI助手',
        type: msg.type || 'text'
    } as Message;
};